export default {
  LIST_FETCHED: 'PRODUCT_ORDERS_FETCHED',
  LIST_LOAD: 'PRODUCT_ORDERS_LOAD',
  TEMPLATES_FETCHED: 'PRODUCT_ORDERS_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'PRODUCT_ORDERS_TEMPLATES_LOAD',
  ITEM_DETAIL_LOAD: 'PRODUCT_ORDERS_DETAIL_LOAD',
  ITEM_DETAIL: 'PRODUCT_ORDERS_DETAIL',
  BUTTON_LOAD: 'PRODUCT_ORDERS_BUTTON_LOAD',
};
